import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { CommonModule } from '@angular/common';
import { OnboardingStepOneComponent } from "../../components/onboarding/onboarding-step-one/onboarding-step-one.component";
import { OnboardingStepTwoComponent } from "../../components/onboarding/onboarding-step-two/onboarding-step-two.component";
import { OnboardingStepThreeComponent } from "../../components/onboarding/onboarding-step-three/onboarding-step-three.component";
import { OnboardingStepFourComponent } from "../../components/onboarding/onboarding-step-four/onboarding-step-four.component";
import { OnboardingStepFourUploadComponent } from "../../components/onboarding/onboarding-step-four-upload/onboarding-step-four-upload.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [LogoComponent, CommonModule, OnboardingStepOneComponent, OnboardingStepTwoComponent, OnboardingStepThreeComponent, OnboardingStepFourComponent, OnboardingStepFourUploadComponent, TranslocoPipe],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.css'
})
export class OnboardingComponent implements OnInit {
  localizedStepInfoArray: string[] = [
    `Personal Information`,
    `Company Information`,
    `Workspace Customisation`,
    `Workspace Customisation`,
    `Workspace Customisation`,
  ];

  currentStep: number | null = null;

  selectedOptionPageFour: string = 'upload';

  constructor(private router: Router, private route: ActivatedRoute, private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (!params['step']) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { step: 1 },
          queryParamsHandling: 'merge',
        });
      }
      else {
        this.currentStep = Number(params['step']) || 7;
      }
    });

    // Populate with translations
    const stepKeys = [
      'shared.labels.personal_information',
      'shared.company_information',
      'auth.onboarding_page.steps.workspace_customisation',
      'auth.onboarding_page.steps.workspace_customisation',
      'auth.onboarding_page.steps.workspace_customisation',
    ];

    combineLatest(stepKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.localizedStepInfoArray = translations;
    });

  }

}
